import { loader } from 'graphql.macro'

export default async function updateOnlineScheduleResourceType ({ dataLoaders, variables }) {
  const updateOnlineScheduleResourceTypeSchema = loader('./updateOnlineScheduleResourceType.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(
    updateOnlineScheduleResourceTypeSchema,
    { input: variables }
  )
  return response.updateOnlineScheduleResourceType
}
